import Button from "@mui/joy/Button";
import Input from "@mui/joy/Input";
import React from "react";
import { Tables } from "../../supabase/supabase";
import WorldMap, { GeoPoint } from "../worlds/WorldMap";
import Scoreboard from "./Scoreboard";

interface TriviaStartProps {
  beginQuiz: () => void;
  updateName: (name: string) => void;
  name?: string;
  userId: number;
  todayTriviaScores: Tables<"triviaScores">[];
  allTimeTriviaScores: Tables<"triviaScores">[];
  allTimeTriviaScoresForGlobe: Tables<"triviaScores">[];
  year: number;
}

export default function TriviaStart({
  beginQuiz,
  todayTriviaScores,
  allTimeTriviaScores,
  allTimeTriviaScoresForGlobe,
  updateName,
  name,
  userId,
  year,
}: TriviaStartProps) {
  const globePoints: GeoPoint[] = allTimeTriviaScoresForGlobe
    .map((score) => {
      const { latitude, longitude } = score;
      if (latitude && longitude) {
        return {
          lat: parseFloat(latitude),
          lng: parseFloat(longitude),
          radius: 50,
          color: "#e70c0cff",
          altitude: 100,
        };
      }
      return undefined;
    })
    .filter((point): point is GeoPoint => point !== undefined);

  return (
    <div className="h-full flex flex-col items-center justify-center gap-8 p-4 text-blue-600">
      <div className="text-4xl font-bold mb-4 text-center">
        <span>Welcome to</span>
        <br />
        <span className="pulse-text-0">Ashbury Amigos</span>
        <br />
        <span>{year} Trivia!</span>
      </div>

      <Scoreboard
        todayTriviaScores={todayTriviaScores}
        allTimeTriviaScores={allTimeTriviaScores}
        userId={userId}
      />

      <div className="flex flex-row items-center gap-2">
        <Input
          color="primary"
          placeholder="Enter your name"
          size="lg"
          variant="outlined"
          onChange={(e) => {
            updateName(e.target.value);
          }}
        />

        <Button
          onClick={() => {
            beginQuiz();
          }}
          size="lg"
          variant="solid"
          disabled={!name}
        >
          Begin
        </Button>
      </div>
      <WorldMap globePoints={globePoints} />
    </div>
  );
}
